module.exports = __webpack_public_path__ + "static/img/twjd-sdo22.09dc7dc.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/twjd-sdo22.png
// module id = 151
// module chunks = 0